import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

// Re-initializes Pagy pagination and Bootstrap tooltips on connect.
// Use in turbo_stream responses that update paginated or tooltip content.
//
// Usage:
//   <div data-controller="turbo-reinit"
//        data-turbo-reinit-pagy-value="true"
//        data-turbo-reinit-tooltips-value="true">
//   </div>
export default class TurboReinitController extends Controller {
  static values = {
    pagy: { type: Boolean, default: false },
    tooltips: { type: Boolean, default: false },
  };

  connect() {
    if (this.pagyValue && typeof Pagy !== 'undefined') {
      Pagy.init();
    }

    if (this.tooltipsValue) {
      document
        .querySelectorAll('[data-bs-toggle="tooltip"]')
        .forEach((el) => {
          new bootstrap.Tooltip(el);
        });
    }

    this.element.remove();
  }
}
